import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import { caseUuidToCopyFromSchema } from 'app/edozvola/cases/construction-participants/model/construction-participants.schema';
import { Button, Input } from 'edozvola-frontend-lib/dist/ui/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { copySiteSupervisorsFromCaseQuery } from 'app/edozvola/cases/construction-participants/service/construction-participants.queries';
import SiteSupervisorTable from 'app/edozvola/cases/construction-participants/site-supervisor/site-supervisor-table';
import SiteSupervisorForm from 'app/edozvola/cases/construction-participants/site-supervisor/site-supervisor.form';
import { getCaseContext } from 'app/shared/util/context-util';

const SiteSupervisor = () => {
  const { id: uuid } = useParams<{ id: string }>();
  const [idSiteSupervisor, setIdSiteSupervisor] = useState<string | null>(null);
  const [readOnly, setReadOnly] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const copySiteSupervisorFormik = useFormik({
    initialValues: { caseUuidToCopyFrom: '' },
    validationSchema: caseUuidToCopyFromSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: values => copySiteSupervisor(values.caseUuidToCopyFrom),
  });

  const { mutate: copySiteSupervisor, isPending: isCopySiteSupervisorPending } = copySiteSupervisorsFromCaseQuery(
    uuid,
    copySiteSupervisorFormik.resetForm,
  );

  const openNewSiteSupervisorForm = () => {
    setIdSiteSupervisor('');
    setReadOnly(false);
  };

  return (
    <>
      <div className={'form-header'}>Nadzorni inženjeri</div>
      {!sidebarItemPair?.readOnly && (
        <>
          <div className={'d-flex justify-content-end pb-4 gap-2'}>
            <div className={'case-copy-from-other-case'}>
              <Input
                placeholder={'Unesite šifru predmeta'}
                maxLength={255}
                addonAppend={
                  isCopySiteSupervisorPending ? (
                    <FontAwesomeIcon icon="spinner" spin />
                  ) : (
                    <FontAwesomeIcon
                      aria-disabled={
                        (!!copySiteSupervisorFormik.errors && !!copySiteSupervisorFormik.errors.caseUuidToCopyFrom) ||
                        copySiteSupervisorFormik.values.caseUuidToCopyFrom === ''
                      }
                      className={
                        (!!copySiteSupervisorFormik.errors && !!copySiteSupervisorFormik.errors.caseUuidToCopyFrom) ||
                        copySiteSupervisorFormik.values.caseUuidToCopyFrom === ''
                          ? 'disabled'
                          : ''
                      }
                      icon="copy"
                    />
                  )
                }
                value={copySiteSupervisorFormik.values.caseUuidToCopyFrom}
                onChange={event => {
                  copySiteSupervisorFormik.setFieldValue('caseUuidToCopyFrom', event.target.value);

                  if (copySiteSupervisorFormik.submitCount > 0) {
                    copySiteSupervisorFormik.setErrors({});
                  }
                }}
                addonAppendClick={() => {
                  if (!isCopySiteSupervisorPending) {
                    copySiteSupervisorFormik.handleSubmit();
                  }
                }}
                error={
                  copySiteSupervisorFormik.errors && copySiteSupervisorFormik.errors.caseUuidToCopyFrom
                    ? copySiteSupervisorFormik.errors.caseUuidToCopyFrom
                    : ''
                }
              />
            </div>
            <div>
              <Button
                label={'Dodaj nadzornog inženjera'}
                color={'info'}
                prependIcon={'plus'}
                size={'lg'}
                onClick={openNewSiteSupervisorForm}
              />
            </div>
          </div>
        </>
      )}

      <>
        <SiteSupervisorTable setSiteSupervisor={setIdSiteSupervisor} setReadOnly={setReadOnly} />
        {idSiteSupervisor !== null && (
          <SiteSupervisorForm idSiteSupervisor={idSiteSupervisor} setIdSiteSupervisor={setIdSiteSupervisor} readOnly={readOnly} />
        )}
      </>
    </>
  );
};

export default SiteSupervisor;
